import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/expense-actions.module.scss';
import { IExpense } from 'src/types/expense';
import DeleteExpenseAction from './DeleteExpenseAction';

const ExpenseActionsColumn: React.FunctionComponent<CellProps<IExpense>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IExpense>) => {
    return (
        <div className={classNames(styles.actions)}>
            {original.status !== 4 ? (
                <div className={'d-flex'}>
                    <Link className="btn btn-info mr-2" to={Router.generate(routes.EXPENSE_EDIT, { id: original.id })}>
                        <FontAwesomeIcon icon={faPencilAlt} />
                    </Link>
                    <DeleteExpenseAction data={original} />
                </div>
            ) : null}
        </div>
    );
};

export default ExpenseActionsColumn;
